import {
    $, addAction, INIT, LAYOUTEND, SCROLL,
} from '@situation/setdesign.util';

// Toggles body.sticky-cta--scrolled once the page leaves the top, so the mobile
// "8 Weeks" half of the sticky CTA bar can hide (see _inline-buttons.scss).
addAction(INIT, () => {
    if (!$('.inline-buttons').length) {
        return;
    }

    const $body = $('body');
    const update = () => $body.toggleClass('sticky-cta--scrolled', window.scrollY > 0);
    addAction(SCROLL, update);
    addAction(LAYOUTEND, update);
    update();
});
